import React from 'react';
import { array, bool } from 'prop-types';
import styled from 'styled-components';

// COMPONENTS
import { BackgroundAndPreview } from './BackgroundAndPreview';
import { Slider } from './components/Slider';
import { Info } from './components/Info';
import GradientBg from 'components/views/vod/components/GradientBg';

// HOOKS
import { useCarousel } from './useCarousel';

// HELPERS
import { CONTAINER_SCREEN_PERCENT } from './helpers';

const Root = styled.div`
	position: relative;
	padding-top: 8vh;
	background-color: #000;
	min-height: 100vh;
`;

const GradientAfter = styled.div`
	position: absolute;
	bottom: -35vh;
	height: 35vh;
	width: 100%;
	z-index: -1;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 1) 0%,
		rgba(0, 0, 0, 1) 40%,
		rgba(0, 0, 0, 0.4) 70%,
		rgba(0, 0, 0, 0) 100%
	);
`;

const InfoWrapper = styled.div`
	width: 40vw;
	max-width: 1100px;
	min-width: 45rem;
	position: relative;
	margin-left: 5.8vw;
	z-index: 4;
`;

const SliderWrapper = styled.div`
	position: relative;
	z-index: 4;
`;

export function Carousel({ itemsList, showGradientAfter, id, name }) {
	const {
		currentIndex,
		changeCurrentIndex,
		stopStartCarousel,
		startCarousel
	} = useCarousel(itemsList);

	return (
		<Root
			id="carousel_slider"
			isSeries={itemsList[currentIndex].subtype === 'series'}
		>
			{itemsList.length > 0 && (
				<>
					<BackgroundAndPreview
						content={itemsList}
						currentIndex={currentIndex}
					/>
					<GradientBg containerScreenPercent={CONTAINER_SCREEN_PERCENT} />
					<InfoWrapper>
						<Info
							startCarousel={startCarousel}
							stopStartCarousel={stopStartCarousel}
							product={itemsList[currentIndex]}
						/>
					</InfoWrapper>
					<SliderWrapper>
						<Slider
							itemsList={itemsList}
							changeCurrentIndex={changeCurrentIndex}
							currentIndex={currentIndex}
							id={id}
							name={name}
						/>
					</SliderWrapper>
				</>
			)}
			{showGradientAfter && <GradientAfter />}
		</Root>
	);
}

Carousel.defaultProps = {
	showGradientAfter: true
};

Carousel.propTypes = {
	itemsList: array.isRequired,
	showGradientAfter: bool
};
